import { Component, OnInit, Input } from '@angular/core';
import { Validators, AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { UserStore } from '../../../services/stores/user.store';
import { UserModel } from '../../../models/user/user.model';
import { ChangePasswordModel } from '../../../models/user/change-password.model';
import { NotificationType } from 'angular2-notifications';
import { UserService } from '../../../services/user.service';
import { AlertService } from '../../../services/alert.service';
import { DashboardHelper } from '../../../services/dashboard.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  standalone: false,
})
export class ChangePasswordComponent implements OnInit {
  changePwdForm: FormGroup = new FormGroup({});
  currentUser: any;
  changePasswordModel: ChangePasswordModel = new ChangePasswordModel({});
  @Input() selectedUser: UserModel | null = null;

  constructor(
    private user2Store: UserStore,
    private userService: UserService,
    private alertService: AlertService,
    private dashboardHelper: DashboardHelper,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.createForm();
    this.currentUser = this.userService.user;
  }

  createForm() {
    this.dashboardHelper.setSharedRightPanelHeaderTitle('Profile Settings');
    this.changePwdForm = this.fb.group(
      {
        credential: ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*[_!@#$%^&*()])(?=.*?[0-9]).{8,}$')]],
        confirmCredential: ['', Validators.required],
      },
      { validator: PasswordValidation.PasswordMatch },
    );
  }

  get f() {
    return this.changePwdForm.controls;
  }

  save() {
    const formModel = this.changePwdForm.value;

    if (this.selectedUser && this.selectedUser.id !== this.currentUser.id) {
      this.changePasswordModel = new ChangePasswordModel({
        id: this.selectedUser.id,
        oldPassword: this.selectedUser.credential,
        password: formModel.credential,
      });
    } else {
      this.changePasswordModel = new ChangePasswordModel({
        id: this.currentUser.id,
        password: formModel.credential,
      });
    }

    this.user2Store.$changePassword(this.changePasswordModel).subscribe((success) => {
      if (success) {
        if (this.selectedUser && this.selectedUser.id !== this.currentUser.id) {
          this.alertService.alert(NotificationType.Success, 'Password Updated Successfully', true);

          for (const name in this.changePwdForm.controls) {
            this.changePwdForm.controls[name].setValue('');
            this.changePwdForm.controls[name].setErrors(null);
          }
          this.changePwdForm.markAsPristine();
          this.changePwdForm.markAsUntouched();
        } else {
          this.alertService.alert(NotificationType.Success, 'Password updated. Please login again', true);
          this.userService.logout();
        }
      } else {
        this.alertService.alert(NotificationType.Error, 'Error changing password!', true);
      }
    });
  }
}

export class PasswordValidation {
  public static PasswordMatch(control: AbstractControl) {
    const credential = control?.get('credential')?.value;
    const confirmCredential = control?.get('confirmCredential')?.value; // to get value in input tag
    if (confirmCredential) {
      if (confirmCredential !== credential) {
        control?.get('confirmCredential')?.setErrors({ ['passwordmatch']: true });
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}
